"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHttpError = exports.HttpError = exports.axiosErrorFields = void 0;
const headers_1 = require("./headers");
exports.axiosErrorFields = [
    'code',
    'config',
    'request',
    'response',
    'toJSON',
    '__CANCEL__',
];
class HttpError extends Error {
    constructor(error) {
        var _a;
        super(error.message);
        this.isWixHttpError = true;
        Object.setPrototypeOf(this, HttpError.prototype);
        exports.axiosErrorFields.forEach((key) => {
            // index is type checked, but converting into 'any' as suggested in Typescript issues.
            this[key] = error[key];
        });
        if ((_a = this.response) === null || _a === void 0 ? void 0 : _a.headers) {
            this.response.requestId = (0, headers_1.requestIdOrEmptyString)(this.response);
        }
    }
    get requestId() {
        return (0, headers_1.requestIdOrEmptyString)(this.response);
    }
}
exports.HttpError = HttpError;
function createHttpError(...args) {
    return new HttpError(...args);
}
exports.createHttpError = createHttpError;
//# sourceMappingURL=error.js.map